import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addComment } from '../../actions/post';

const CommentForm = ({ postId, addComment, auth: { user } }) => {
  const [text, setText] = useState('');

  return (
    <div className="comment-form">
      <hr className="my-0" />

      <div className="card-body pt-2 pb-1">
        <form
          className="pb-1"
          onSubmit={(e) => {
            e.preventDefault();
            addComment(postId, { text });
            setText('');
          }}
        >
          <div className="form-group row my-0">
            <label
              htmlFor="new-post-text"
              className="col-1 col-form-label py-0"
            >
              <img
                src={user.avatar}
                className="rounded-circle comment-form-profile-pic"
                alt=""
              />
            </label>
            <div className="col-9 col-xl-10 ml-3 ml-md-2 ml-xl-0 align-self-center">
              <textarea
                className="form-control form-control-sm shadow-sm"
                id="comment-form-text"
                placeholder="Write a comment..."
                rows="1"
                value={text}
                onChange={(e) => setText(e.target.value)}
                required
              ></textarea>
            </div>
            <div className="col-1 align-self-center px-0 mx-auto">
              <button
                className="btn btn-secondary btn-sm px-2 py-0"
                type="submit"
              >
                <i className="fas fa-feather-alt"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

CommentForm.propTypes = {
  addComment: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, { addComment })(CommentForm);
